import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import 'code-highlight/lib/style.css';
import 'highlight.js/styles/github-gist.css';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'Navigations',
    breadcrumbName: 'Navigations',
  },
];

const Navigations = () => {
  return (
    <>

      <PageHeader title="Navigations" breadcrumb={{ routes }} subTitle="Navigation-horizontal" style={{ padding: 10 }}/>

      <div className="MF_area">
        <nav className="category_horizontal_area">
          <ul className="main_category">
            <li className="active"><a>Category_1</a></li>
            <li className=""><a>Category_2</a></li>
            <li className=""><a>Category_3</a></li>
            <li className=""><a>Category_4</a></li>
            <li className=""><a>Category_5</a></li>
          </ul>
          <ul className="sub_category">
            <li className="s_active"><a>SubCategory_1</a></li>
            <li><a>SubCategory_2</a></li>
            <li><a>SubCategory_3</a></li>
            <li><a>SubCategory_4</a></li>
            <li><a>SubCategory_5</a></li>
          </ul>
        </nav>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<nav class="category_horizontal_area">
  <ul class="main_category">
    <li class="active"><a>Category_1</a></li>
    <li class=""><a>Category_2</a></li>
    <li class=""><a>Category_3</a></li>
    <li class=""><a>Category_4</a></li>
    <li class=""><a>Category_5</a></li>
  </ul>
  <ul class="sub_category">
    <li class="s_active"><a>SubCategory_1</a></li>
    <li><a>SubCategory_2</a></li>
    <li><a>SubCategory_3</a></li>
    <li><a>SubCategory_4</a></li>
    <li><a>SubCategory_5</a></li>
  </ul>
</nav>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

      <PageHeader title="Navigations" breadcrumb={{ routes }} subTitle="Navigation-horizontal-Event" style={{ padding: 10 }}/>

      <div className="MF_area">
        <nav className="category_horizontal_area" data-rule="category">
          <ul className="main_category">
            <li className="active">
              <a>Category_1</a>
              <ul className="sub_category">
                <li className="s_active"><a>SubCategory_1</a></li>
                <li><a>SubCategory_1</a></li>
                <li><a>SubCategory_1</a></li>
              </ul>
            </li>
            <li className="">
              <a>Category_2</a>
              <ul className="sub_category">
                <li className="s_active"><a>SubCategory_2</a></li>
                <li><a>SubCategory_2</a></li>
                <li><a>SubCategory_2</a></li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<nav class="category_horizontal_area" data-rule="category">
  <ul class="main_category">
    <li class="active">
        <a>Category_1</a>
        <ul class="sub_category">
          <li class="s_active"><a>SubCategory_1</a></li>
          <li><a>SubCategory_1</a></li>
          <li><a>SubCategory_1</a></li>
        </ul>
    </li>
    <li class="">
        <a>Category_2</a>
        <ul class="sub_category">
          <li class="s_active"><a>SubCategory_2</a></li>
          <li><a>SubCategory_2</a></li>
          <li><a>SubCategory_2</a></li>
        </ul>
    </li>
  </ul>
</nav>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

      <PageHeader title="Navigations" breadcrumb={{ routes }} subTitle="Navigation-horizontal-equal-division" style={{ padding: 10 }}/>

      <div className="MF_area">
        <nav className="category_horizontal_area" data-rule="category">
          <ul className="main_category equal_division">
            <li className="active">
              <a>Category_1</a>
              <ul className="sub_category equal_division">
                <li className="s_active"><a>SubCategory_1</a></li>
                <li><a>SubCategory_1</a></li>
                <li><a>SubCategory_1</a></li>
              </ul>
            </li>
            <li className="">
              <a>Category_2</a>
              <ul className="sub_category">
                <li className="s_active"><a>SubCategory_2</a></li>
                <li><a>SubCategory_2</a></li>
                <li><a>SubCategory_2</a></li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<nav class="category_horizontal_area" data-rule="category">
  <ul class="main_category">
    <li class="active">
        <a>Category_1</a>
        <ul class="sub_category">
          <li class="s_active"><a>SubCategory_1</a></li>
          <li><a>SubCategory_1</a></li>
          <li><a>SubCategory_1</a></li>
        </ul>
    </li>
    <li class="">
        <a>Category_2</a>
        <ul class="sub_category">
          <li class="s_active"><a>SubCategory_2</a></li>
          <li><a>SubCategory_2</a></li>
          <li><a>SubCategory_2</a></li>
        </ul>
    </li>
  </ul>
</nav>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

      <PageHeader title="Navigations" breadcrumb={{ routes }} subTitle="Navigation-Vertical" style={{ padding: 10 }}/>

      <div className="MF_area">
        <div className="category_vertical_area">
          <div className="nav_subject">
            <a>카테고리
              <div>Category</div>
            </a>
          </div>
          <div className="nav">
            <div className="nav_title"><a>Category_1</a></div>
            <div className="nav_title"><a>Category_2</a></div>
            <div className="nav_title active"><a>Category_3</a></div>
            <div className="nav_title"><a>Category_4</a></div>
            <div className="nav_title"><a>Category_5</a></div>
            <div className="nav_title"><a>Category_6</a></div>
            <div className="nav_title"><a>Category_7</a></div>
            <ul className="nav_sub">
              <li className=""><a>SubCategory_1</a></li>
              <li className="s_active"><a>SubCategory_2</a></li>
              <li className=""><a>SubCategory_3</a></li>
            </ul>
            <div className="nav_title"><a>Category_8</a></div>
            <ul className="nav_sub">
              <li className=""><a>SubCategory_1</a></li>
              <li className=""><a>SubCategory_2</a></li>
              <li className=""><a>SubCategory_3</a></li>
              <li className=""><a>SubCategory_4</a></li>
            </ul>
            <div className="nav_title"><a>Category_9</a></div>
            <div className="nav_title"><a>Category_10</a></div>
            <div className="nav_title"><a>Category_11</a></div>
            <div className="nav_title"><a>Category_12</a></div>
            <div className="nav_title"><a>Category_13</a></div>
            <div className="nav_title"><a>Category_14</a></div>
            <div className="nav_title"><a>Category_15</a></div>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="category_vertical_area">
  <div class="nav_subject">
    <a >카테고리
        <div>Category</div>
    </a>
  </div>
  <div class="nav">
    <div class="nav_title"><a >Category_1</a></div>
    <div class="nav_title"><a >Category_2</a></div>
    <div class="nav_title active"><a >Category_3</a></div>
    <div class="nav_title"><a >Category_4</a></div>
    <div class="nav_title"><a >Category_5</a></div>
    <div class="nav_title"><a >Category_6</a></div>
    <div class="nav_title"><a >Category_7</a></div>
    <ul class="nav_sub">
      <li class=""><a >SubCategory_1</a></li>
      <li class="s_active"><a>SubCategory_2</a></li>
      <li class=""><a >SubCategory_3</a></li>
    </ul>
    <div class="nav_title"><a >Category_8</a></div>
    <ul class="nav_sub">
      <li class=""><a >SubCategory_1</a></li>
      <li class=""><a >SubCategory_2</a></li>
      <li class=""><a >SubCategory_3</a></li>
      <li class=""><a >SubCategory_4</a></li>
    </ul>
    <div class="nav_title"><a >Category_9</a></div>
    <div class="nav_title"><a >Category_10</a></div>
    <div class="nav_title"><a >Category_11</a></div>
    <div class="nav_title"><a >Category_12</a></div>
    <div class="nav_title"><a >Category_13</a></div>
    <div class="nav_title"><a >Category_14</a></div>
    <div class="nav_title"><a >Category_15</a></div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default Navigations;
